/* eslint-disable react/jsx-props-no-spreading */
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../partials/HeaderDefault';

import styles from '../../../../styles/themes/coorslive/header-coorslive.module.css';

function HeaderCoorslive({ ...props }) {
    return (
        <HeaderDefault
            menuLabel={
                <div className={styles.menu}>
                    <span className={styles.label}>
                        <FormattedMessage defaultMessage="Menu" description="button label" />
                    </span>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={styles.icon}
                    >
                        <path d="M3 6H21V8H3V6Z" fill="white" />
                        <path d="M3 11H21V13H3V11Z" fill="white" />
                        <path d="M3 16H21V18H3V16Z" fill="white" />
                    </svg>
                </div>
            }
            {...props}
        />
    );
}

export default HeaderCoorslive;
